module.exports = __webpack_public_path__ + "img/collar_width.8ecea4b4.png";